import GetCampaignFieldMappingsRequestModelBase from '../_generated/modelBases/get-campaign-field-mappings-request-model-base';

export default class GetCampaignFieldMappingsRequestModel extends GetCampaignFieldMappingsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
